export default __webpack_public_path__ + "static/media/esri-deployment.00472706.png";